import clsx from "clsx";

interface LegendProps {
  subjectSlug: string;
}

export default function Legend({ subjectSlug }: LegendProps): JSX.Element {
  return (
    <>
      <div
        className={clsx("flex-shrink-0 mr-3 w-4 h-4 rounded-sm")}
        style={{ backgroundColor: legendColor(subjectSlug) }}
      ></div>
    </>
  );
}

export function legendColor(subjectSlug: string): string {
  const colors = {
    biologia: "#49028e",
    fisica: "#6402c5",
    matematica: "#8000ff",
    quimica: "#8c17ff",
    arte: "#427816",
    espanhol: "#559a1c",
    ingles: "#6ec725",
    portugues: "#83e92f",
    filosofia: "#b50b6c",
    geografia: "#db0e83",
    historia: "#f81195",
    literatura: "#ff1c9e",
    sociologia: "#ff30a6"
  };
  return colors[subjectSlug];
}
